import '../style/global.css';
import Logo from '../assets/full-logo.png'
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import Kakao from "../assets/kakao.png";
import Instagram from "../assets/instagram.png";
import Naver from "../assets/naver.png";

const menuMap: { label: string, value: string }[] = [
  {label: '강사 정보', value: '/instructor'},
  {label: '강습 신청', value: '/apply'},
  {label: '가격표', value: '/price'},
  {label: '자주묻는질문', value: '/faq'},
]

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleMenuClick = (page: string) => {
    navigate(page);
  }
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768)
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={'nav-container'}>
      <img className={'nav-logo'} src={Logo} alt={'BLUESKI'} onClick={() => navigate('/')}/>
      {isMobile ? (
        <MenuIcon sx={{cursor: 'pointer'}} onClick={() => setIsSidebarOpen(true)}/>
      ) : (
        <div className={'nav-menu-container'}>
          {menuMap.map((menu, index) => (
            <div key={index} className={`nav-menu ${location.pathname === menu.value && 'selected'}`}
                 onClick={() => handleMenuClick(menu.value)}>
              {menu.label}
            </div>
          ))}
        </div>
      )}
      {isSidebarOpen && (
        <div className={'nav-sidebar-bg'} onClick={() => setIsSidebarOpen(false)}>
          <div className={'nav-sidebar'} onClick={(e) => e.stopPropagation()}>
            <CloseIcon className={'nav-sidebar-close'} onClick={() => setIsSidebarOpen(false)}/>
            <div className={'nav-menu-container'}>
              {menuMap.map((menu) => (
                <div className={`nav-mobile-menu ${location.pathname === menu.value && 'selected'}`}
                     onClick={() => handleMenuClick(menu.value)}>
                  {menu.label}
                </div>
              ))}
            </div>
            <div className={'nav-sidebar-links'}>
              <img className={'nav-sidebar-link-icon'} src={Kakao} alt={'카카오톡 플러스친구'}
                   onClick={() => window.open("http://pf.kakao.com/_xnSjVn", "_blank")}/>
              <img className={'nav-sidebar-link-icon'} src={Instagram} alt={'인스타그램'}
                   onClick={() => window.open("https://www.instagram.com/Blue_skischool", "_blank")}/>
              <img className={'nav-sidebar-link-icon'} src={Naver} alt={'네이버 스마트스토어'}
                   onClick={() => window.open("https://m.smartstore.naver.com/blueskischool9598", "_blank")}/>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default Navigation;